var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CommonHeader',{attrs:{"page":'Historique caisse'}}),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('CaisseTable',{attrs:{"title":"Historique caisse"}})],1)])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }